<template>
  <div
    id="error-page"
    class="error-page flex flex-wrap pa-0 pt-5">
    <div
      class="flex flex-space width-100">
      <div
        class="col-img">
        <img
          :src="`${siteHref}/img/error/${image}.svg`">
      </div>
      <div
        class="col-content">
        <component
          :is="componentName"
          :data-qa="componentName"/>
      </div>
    </div>
    <ManagerCard class="mt-auto"/>
  </div>
</template>
<script>
import Error404 from 'components/errors/Error404.vue'
import Error403 from 'components/errors/Error403.vue'
import Error500 from 'components/errors/Error500.vue'
import LowBalancePage from 'components/errors/LowBalancePage.vue'
import ManagerCard from 'components/common/blocks/ManagerCard.vue'
import VerificationError from 'components/errors/VerificationError.vue'
import IdentificationError from 'components/errors/IdentificationError.vue'

import { storageMixin } from 'mixins'

export default {
  mixins: [ storageMixin ],
  name: 'error',
  data() {
    return {
      /** Откуда пришли на страницу ошибки */
      from: null,
      type: 'not-found',
      image: null,
      componentName: 'Error404',
      siteHref: window.config?.BaseUrl,
    }
  },
  methods: {
    createComponentName() {
      const code = this.$route.params.status_code + ''
      let result = 'Error404'
      let image = null

      if ( code == '403' ) {
        this.type = this.$route.params.type || 'no-access'
      } else if ( code == '404') {
        this.type = 'not-found'
      } else if ( code?.startsWith('50')) {
        this.type = 'server-error'
      } else {
        this.type = 'not-found'
      }
      switch (this.type) {
      case 'not-found':
        image = 'not-found'
        result = 'Error404'
        break
      case 'no-access':
        image = 'no-access'
        result = 'Error403'
        break
      case 'server-error':
        image = 'server-error'
        result = 'Error500'
        break
      case 'verification-error':
        image = 'verification-error'
        result = 'VerificationError'
        break
      case 'identification-error':
        image = 'identification-error'
        result = 'IdentificationError'
        break
      case 'low-balance':
        image = 'low-balance'
        result = 'LowBalancePage'
        break
      }
      if (image) {
        this.image = image
      }
      this.componentName = result
    }
  },
  watch: {
    '$route.fullPath': {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        if (!oldValue || JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.createComponentName()
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from = from
    })
  },
  beforeMount() {
    let prevPageIsCurrent = this.$_getPropFromLocalStorage('errorPage', '')

    /* http://localhost:8080/95614/tenders/5871769/tender-visits
      1 раз переходить на 404 другий на головну ,
      тепер якщо було переадресування на сторінку помилки такого не буде, перехід на головну тільки якщо перезавантаження сторінки
    */
    const code = this.$route.params.status_code + ''
    if (prevPageIsCurrent === code && !this.$route.meta.from.name) {
      this.$_savePropToLocalStorage('errorPage', '')
      this.$router.push({name: 'homePage'})
      return
    }

    this.$_savePropToLocalStorage('errorPage', code)
  },
  beforeDestroy() {
    this.$_savePropToLocalStorage('errorPage', '')
  },
  components: {
    Error404,
    Error403,
    Error500,
    ManagerCard,
    LowBalancePage,
    VerificationError,
    IdentificationError,
  }
}
</script>
<style lang="scss" scoped>
.error-page {
  height: 100%;
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: var(--v-main__green-base);
}
.col-img {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 30%;
  z-index: 1;
  @media (max-width: 935px) {
    position: absolute;
    z-index: 0;
    opacity: 0.1;
    width: 100%;
    justify-content: center;
  }
}
.col-content {
  align-items: center;
  display: flex;
  width: 50%;
  z-index: 2;
  @media (max-width: 935px) {
    width: 100%;
    padding: 0 20px;
    justify-content: center;
  }
}
</style>
